import { ShieldCheck, Leaf, Heart } from "lucide-react";

const OWNER_IMG = "/images/owner-karie.jpg";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Class 3 Licensed",
    body: "Oregon-licensed Class 3 Adult Foster Home, authorized to care for residents with complex medical and cognitive needs.",
  },
  {
    icon: Heart,
    title: "Family-First",
    body: "Every resident is welcomed as part of our family — not a number on a chart or a room at the end of a hallway.",
  },
  {
    icon: Leaf,
    title: "Quiet & Dignified",
    body: "A calm home on rural Stayton Scio Rd, with home-cooked meals, gentle routines, and unhurried one-on-one attention.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#F4F1EA] rounded-[28px] -z-10" />
              <img
                src={OWNER_IMG}
                alt="Karie Andrews, owner of Carlene's Comfort Care"
                className="rounded-3xl w-full object-cover aspect-[4/5] shadow-[0_20px_60px_-24px_rgba(44,76,59,0.35)]"
                loading="lazy"
              />
              <div className="absolute -bottom-6 -right-6 bg-white border border-[#E5E1D8] rounded-2xl px-5 py-4 shadow-[0_12px_32px_-12px_rgba(44,76,59,0.18)] hidden sm:block">
                <p className="font-heading text-xl text-[#2C4C3B] leading-tight">
                  Karie Andrews
                </p>
                <p className="text-xs uppercase tracking-[0.25em] text-[#667B68] mt-1">
                  Owner &middot; Caregiver
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p
              className="reveal text-xs uppercase tracking-[0.3em] font-semibold text-[#667B68]"
              data-testid="about-eyebrow"
            >
              About Carlene&rsquo;s Comfort Care
            </p>
            <h2
              className="reveal font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#1C2A24] mt-4"
              data-testid="about-title"
              style={{ transitionDelay: "80ms" }}
            >
              A small home,
              <br />
              held with great care.
            </h2>
            <div
              className="reveal mt-8 space-y-5 text-[17px] leading-[1.75] text-[#3E574B] max-w-xl"
              style={{ transitionDelay: "160ms" }}
            >
              <p>
                Carlene&rsquo;s Comfort Care is a family-run Adult Foster Home
                tucked into the countryside of Scio, Oregon. We welcome up to
                five residents at a time — on purpose — so the care stays
                personal, patient, and deeply attentive.
              </p>
              <p>
                Led by owner <strong className="text-[#1C2A24]">Karie Andrews</strong>,
                our team specializes in Alzheimer&rsquo;s, dementia, and
                end-of-life care. As a licensed Class 3 Adult Foster Home, we
                believe the final chapters of life should be met with warmth,
                quiet, and the everyday comforts of home.
              </p>
            </div>

            <div className="reveal grid sm:grid-cols-3 gap-4 mt-10" style={{ transitionDelay: "240ms" }}>
              {PILLARS.map((p) => (
                <div
                  key={p.title}
                  data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group bg-white border border-[#E5E1D8] rounded-2xl p-6 hover:-translate-y-1 hover:shadow-[0_16px_40px_-20px_rgba(44,76,59,0.2)] transition-all duration-300"
                >
                  <p.icon className="w-6 h-6 text-[#2C4C3B]" />
                  <h3 className="font-heading text-xl mt-4 text-[#1C2A24]">
                    {p.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-[#3E574B] mt-2">
                    {p.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
